export default "__VITE_ASSET__ClfAR7kq__"